import React from "react";
import { connect } from "react-redux";
import { removeFromFavorites, addToCart } from "../Redux/Webshop/shop-actions";

// import { BsHeartFill } from "react-icons/bs";
import { GiBrokenHeart } from "react-icons/gi";
import "./Favorite.css";
import Favorites from "./Favorites";

const Favorite = ({ item, removeFromFavorites, addToCart }) => {
  return (
    <div>
     
      <div className="favoriteContainer">
        <h3>{item.title}</h3>
        <img src={item.image} alt={item.alt} className="imgFavorite" />
        <p>{item.description}</p>
        <p>&euro; {item.price}</p>
      </div>
      <div className="favoriteButtons">
        <button
          className="buttonFavorite"
          onClick={() => removeFromFavorites(item.id)}
        >
          <GiBrokenHeart style={{ fontSize: "16px" }} />
        </button>
        <button onClick={() => addToCart(item.id)} className="buttonPO">
          add to basket
        </button>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeFromFavorites: (id) => dispatch(removeFromFavorites(id)),
    addToCart: (id) => dispatch(addToCart(id)),
  };
};

export default connect(null, mapDispatchToProps)(Favorite);
